export class FieldResponse {
    fieldName = "";
    response = "";
}
